import React from 'react';
import { View, Text, StyleSheet } from 'react-native';

import { Utils, NavBar, OPComponent, Navigation } from '../components';
import { COLOR, FONT, FONT_SIZE, THEME, __WEB__ } from '../../constants/styles';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { getCurrentCasePatient, getCurrentCaseEmployer } from '../cases/selector';
import ProviderMain from '../staffScheduling/provider_main';
import GreetingHeader from '../employer/greeting_header';

class MedRecruiterHome extends OPComponent {
  constructor(props) {
    super(props);

    this.state = {};
  }

  renderHeader() {
    if (__WEB__) return this.renderWebHeader();
    const props = this.props;

    return <GreetingHeader employer={props.employer} userProfile={props.userProfile} />;
  }

  renderWebHeader() {
    const props = this.props;

    return <GreetingHeader employer={props.employer} userProfile={props.userProfile} />;
  }

  render() {
    return (
      <View>
        {this.renderHeader()}
        <ProviderMain />
      </View>
    );
  }
}

const styles = StyleSheet.create({});

function mapStateToProps(state) {
  return {
    patient: getCurrentCasePatient(state),
    userProfile: state.entities.userProfile,
    employer: getCurrentCaseEmployer(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({}, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MedRecruiterHome);
